import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propArrayShape } from '../../../../../../helpers/custom-prop-types';
import AdditionalFilesRowThumbnail from './AdditionalFilesRowThumbnail';
const AdditionalFilesRow = (props) => {
    const { additionalFiles } = props;
    if (additionalFiles.length === 0) {
        return null;
    }
    return (_jsxs("div", Object.assign({ className: 'additional_files_row' }, { children: [_jsx("h5", Object.assign({ className: 'title_value' }, { children: "\u6DFB\u4ED8\u8CC7\u6599" })), _jsx("ul", Object.assign({ className: 'additional_files_list' }, { children: additionalFiles.map((additionalFile) => (_jsxs("li", Object.assign({ className: 'additional_files_list_row' }, { children: [_jsx(AdditionalFilesRowThumbnail, { extension: additionalFile.file_extension, thumbnail: additionalFile.thumbnail }), _jsx("a", Object.assign({ className: 'link_value', href: additionalFile.path, rel: 'noopener noreferrer', target: '_blank' }, { children: additionalFile.name }))] }), additionalFile.id))) }))] })));
};
AdditionalFilesRow.propTypes = {
    additionalFiles: propArrayShape().isRequired,
};
export default AdditionalFilesRow;
